import TenantAdminIntegrationView from './TenantAdminIntegrationView';
import './TenantAdminIntegrationView.scss';
import '../TenantAdminBase.scss';

export default TenantAdminIntegrationView;
